import React from 'react'
import './Top.css'

function About() {
  return (
    <div className="about-container">
      <img src={"/about_images/background images.png"} alt="Background" />
      <h1>About Shabdd Technologies</h1>
      <p className="for-p-tag">Your trusted partner for innovative IT solutions designed to empower your business.</p>
    </div>
  )
}

export default About;
